import { useEffect } from "react";

interface JsonLdProps {
  id: string;
  data: Record<string, unknown>;
}

export default function JsonLd({ id, data }: JsonLdProps) {
  const json = JSON.stringify(data);
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = `jsonld-${id}`;
    script.textContent = json;
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById(`jsonld-${id}`);
      if (existing) existing.remove();
    };
  }, [id, json]);
  return null;
}